import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { isDesktop, useTourAnalytics } from '@carboncopyco/utils';
import { BadgeWithTooltip } from '../../../BadgeWithTooltip';
import { NotesInDesktopMessage, SpeakerNotesCard } from '../../../SpeakerNotes';
import { usePermissionsContext } from '../../../utils';
import { TabLayout } from '../../TabLayout';
import { TourPageActionButtons } from '../TourPageActionButtons';
import { TourPageBreadcrumbs } from '../TourPageBreadcrumbs';
import { useTourPageProps } from '../TourPageContext';
import { TourPageTitle } from '../TourPageTitle';

export const SpeakerNotesTab = () => {
  const {
    tourId,
    showNotesInDesktopMessage,
    onCloseNotesInDesktopMessage,
    noteValue,
    setNoteValue,
    readOnly,
  } = useTourPageProps();

  const { getPermissions } = usePermissionsContext();
  const userHasNoteEditingPermission = getPermissions(
    PermissionKey.note,
    PermissionAction.updateNoteById
  );

  const { trackTourAddSpeakerNotes } = useTourAnalytics({
    location: 'tour_page_speaker_notes_tab',
    tourId,
  });

  return (
    <TabLayout
      title={<TourPageTitle />}
      entity="tour"
      breadcrumbs={<TourPageBreadcrumbs />}
      actionButtons={<TourPageActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      <div className="h-full flex flex-col pb-10">
        {!isDesktop() && showNotesInDesktopMessage && (
          <NotesInDesktopMessage onClose={onCloseNotesInDesktopMessage} />
        )}
        <div className="grow">
          <SpeakerNotesCard
            isEditable={!readOnly && userHasNoteEditingPermission}
            entityId={String(tourId)}
            entityType="tour"
            value={noteValue}
            setValue={setNoteValue}
            onAddNote={() => {
              trackTourAddSpeakerNotes();
            }}
          />
        </div>
      </div>
    </TabLayout>
  );
};
